module.exports = __webpack_public_path__ + "img/cohesion.d2cb6590.svg";